import { useState } from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

interface MobileSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  ariaLabel?: string;
}

export function MobileSearchBar({
  value,
  onChange,
  placeholder = 'Buscar...',
  ariaLabel = 'Buscar',
}: MobileSearchBarProps) {
  const [focused, setFocused] = useState(false);

  return (
    <div className="sticky top-0 z-10 -mx-3 border-b bg-background/95 px-3 pb-2 pt-1 backdrop-blur-sm">
      <div className="flex items-center gap-2">
        <div className="relative flex-1">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            value={value}
            onChange={(event) => onChange(event.target.value)}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            placeholder={placeholder}
            aria-label={ariaLabel}
            className="h-10 pl-9"
          />
        </div>

        {focused || value ? (
          <Button
            type="button"
            variant="ghost"
            className="h-10 px-2 text-sm"
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => onChange('')}
          >
            Cancelar
          </Button>
        ) : null}
      </div>
    </div>
  );
}
